import { render } from "./UserFavorites.vue?vue&type=template&id=2ca1696a"
import script from "./UserFavorites.vue?vue&type=script&lang=js"
export * from "./UserFavorites.vue?vue&type=script&lang=js"

import "./UserFavorites.vue?vue&type=style&index=0&id=2ca1696a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__